module.exports = __webpack_public_path__ + "static/img/PS-NA4.e3b8081.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PS-NA4.png
// module id = r/00
// module chunks = 1